import register from '../register';
import PlacesAutoComplete from './classes/places-autocomplete';
import dom from './util/dom';

function validateEmail( str ) {
  return /\S+@\S+/.test( str );
}

class CheckAvailServicePage extends PlacesAutoComplete {
  constructor( opts ) {
    super( opts );
    this.submit = document.querySelector('.get-started');
    this.email = document.querySelector('.inp-email-address');
    // eslint-disable-next-line max-len
    this.component = document.querySelector('.check-avail-service-page-component');
    this.disabled = true;
    this.onSubmit = this.onSubmit.bind( this );
    this.setupEvents();
  }

  onSelect( place ) {
    this.place = place;

    if ( place.suggestion ) {
      // eslint-disable-next-line max-len
      { this.input.value = `${ place.suggestion.name }, ${ place.suggestion.locality }, ${ place.suggestion.state } ${ place.suggestion.postal_code }`; }
      return;
    }

    this._onNoneSelected();
  }

  showEmailError( bool ) {
    let addOrRemove = bool ? 'add' : 'remove';
    let parent = this.email.parentNode;
    parent.classList[ addOrRemove ]('error');
  }

  onSubmit() {
    this.showEmailError( false );
    if ( !validateEmail( this.email.value ) ) {
      this.showEmailError( true );
      return;
    }

    if ( !this.input.value ) {
      this.component.classList.add('address-required-error');
      return;
    }

    if ( window.acumen ) {
      window.acumen.track( 'web-submit-check_availability_email', {
        email: this.email.value
      });
    }

    let submit = fn => fn();

    if ( this.place && this.place.status !== 'open_enrollment' ) {
      const payload = {
        email: this.email.value,
        flow: 'check_availability_email_submit',
        street_number: this.place.street_number,
        street: this.place.street,
        city: this.place.city,
        state: this.place.state,
        postal_code: this.place.postal_code
      };

      if ( this.place._id ) {
        payload.place_id = this.place._id;
      }

      if ( this.place.gis_id ) {
        payload.gis_id = this.place.gis_id;
      }

      if ( this.place.lat && this.place.lng ) {
        payload.lat = this.place.lat;
        payload.lng = this.place.lng;
      }

      submit = fn => {
        let opts = { method: 'POST', url: '/serviceable' };
        this.onLoading();
        dom.ajax( opts, payload, () => fn() );
      };
    }

    submit( () => {
      if ( this.place && this.place._id ) {
        this._onPlaceSelected( this.place );
      } else if ( this.place && !this.place.notfound ) {
        this._onMapboxSelected( this.place );
      } else {
        this._onNoneSelected();
      }
    });
  }

  setupEvents() {
    this.submit.addEventListener( 'click', this.onSubmit );
    this.input.addEventListener( 'input', this.checkSubmitDisabled );
    this.email.addEventListener( 'input', this.checkSubmitDisabled );
  }
}

register( 'check-avail-service-page', () => {
  // eslint-disable-next-line max-len
  const component = document.querySelector('.check-avail-service-page-component');
  const input = component.querySelector('#check-availability-input');
  const list = component.querySelector('.results');
  const hooks = {
    input() {
      component.classList.remove('address-required-error');
    }
  };
  new CheckAvailServicePage({ input, list, hooks });
});

export default undefined;
